{
  "AUTOMATION": {
    "HEADER": "Automatización",
    "DESCRIPTION": "La automatización puede reemplazar y agilizar los procesos existentes que requieren esfuerzo manual, como añadir etiquetas y asignar conversaciones al agente más adecuado. Esto permite al equipo concentrarse en sus fortalezas, mientras que reduce el tiempo dedicado a las tareas de rutina.",
    "LEARN_MORE": "Aprende más sobre automatización",
    "HEADER_BTN_TXT": "Añadir regla de automatización",
    "LOADING": "Obteniendo reglas de automatización",
    "ADD": {
      "TITLE": "Añadir regla de automatización",
      "SUBMIT": "Crear",
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "FORM": {
        "NAME": {
          "LABEL": "Nombre de regla",
          "PLACEHOLDER": "Introduzca el nombre de regla",
          "ERROR": "El nombre es requerido"
        },
        "DESC": {
          "LABEL": "Descripción",
          "PLACEHOLDER": "Introduce la descripción de la regla",
          "ERROR": "Descripción requerida"
        },
        "EVENT": {
          "LABEL": "Evento",
          "PLACEHOLDER": "Por favor, seleccione uno",
          "ERROR": "El evento es requerido"
        },
        "CONDITIONS": {
          "LABEL": "Condiciones"
        },
        "ACTIONS": {
          "LABEL": "Acciones"
        },
        "PHASE": {
          "LABEL": "Fase"
        },
        "ORDER": {
          "LABEL": "Orden",
          "ERROR": "El orden es obligatorio"
        }
      },
      "CONDITION_BUTTON_LABEL": "Añadir condición",
      "ACTION_BUTTON_LABEL": "Añadir Acción",
      "API": {
        "SUCCESS_MESSAGE": "Regla de automatización añadida correctamente",
        "ERROR_MESSAGE": "No se pudo crear una regla de automatización, por favor inténtalo de nuevo más tarde"
      }
    },
    "LIST": {
      "404": "No se encontraron reglas de automatización",
      "TABLE_HEADER": {
        "NAME": "Nombre",
        "DESCRIPTION": "Descripción",
        "ACTIVE": "Activo",
        "CREATED_ON": "Creado el",
        "PHASE": "Fase",
        "ORDER": "Orden",
        "WAIT": "Espera"
      },
      "TABS": {
        "ALL": "Todas",
        "INSTANT": "Al ocurrir el evento",
        "DELAYED": "Con retraso"
      },
      "WAITS": "Espera {duration}"
    },
    "DELETE": {
      "TITLE": "Eliminar regla de automatización",
      "SUBMIT": "Eliminar",
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "CONFIRM": {
        "TITLE": "Confirmar eliminación",
        "MESSAGE": "¿Está seguro de eliminar ",
        "YES": "Sí, eliminar ",
        "NO": "No, mantenerlo "
      },
      "API": {
        "SUCCESS_MESSAGE": "Regla de automatización eliminada correctamente",
        "ERROR_MESSAGE": "No se pudo eliminar una regla de automatización, por favor inténtalo más tarde"
      }
    },
    "EDIT": {
      "TITLE": "Editar regla de automatización",
      "SUBMIT": "Actualizar",
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "API": {
        "SUCCESS_MESSAGE": "Regla de automatización actualizada correctamente",
        "ERROR_MESSAGE": "No se pudo actualizar la regla de automatización, por favor inténtalo más tarde"
      }
    },
    "CLONE": {
      "TOOLTIP": "Clonar",
      "API": {
        "SUCCESS_MESSAGE": "Automatización clonada con éxito",
        "ERROR_MESSAGE": "No se pudo clonar la regla de automatización, por favor inténtalo más tarde"
      }
    },
    "FORM": {
      "EDIT": "Editar",
      "CREATE": "Crear",
      "DELETE": "Eliminar",
      "CANCEL": "Cancelar",
      "RESET_MESSAGE": "El cambio de tipo de evento restablecerá las condiciones y eventos que has añadido abajo"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Necesitas tener al menos una condición para guardar",
      "CONTACT_CUSTOM_ATTR_LABEL": "Atributos personalizados del contacto",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Atributos personalizados de la conversación"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Necesitas tener al menos una acción para guardar",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Introduzca su mensaje aquí",
      "TEAM_DROPDOWN_PLACEHOLDER": "Seleccionar equipos",
      "EMAIL_INPUT_PLACEHOLDER": "Introducir email",
      "URL_INPUT_PLACEHOLDER": "Introducir URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Selecciona la bandeja de entrada de correo electrónico y la dirección de envío",
      "SUBJECT_INPUT_PLACEHOLDER": "Asunto del correo electrónico",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Selecciona la bandeja de entrada de SMS desde la que enviar",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Introduce el texto del SMS",
      "SMS_COUNTER": "{length}/{limit} caracteres, {segments} SMS (antes de rellenar las variables)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Activar regla de automatización",
      "DEACTIVATION_TITLE": "Desactivar regla de automatización",
      "ACTIVATION_DESCRIPTION": "Esta acción activará la regla de automatización '{automationName}'. ¿Seguro que desea continuar?",
      "DEACTIVATION_DESCRIPTION": "Esta acción desactivará la regla de automatización '{automationName}'. ¿Está seguro que desea continuar?",
      "ACTIVATION_SUCCESFUL": "Regla de automatización activada con éxito",
      "DEACTIVATION_SUCCESFUL": "Regla de automatización desactivada con éxito",
      "ACTIVATION_ERROR": "No se pudo activar la automatización, por favor inténtelo de nuevo más tarde",
      "DEACTIVATION_ERROR": "No se pudo desactivar la automatización, por favor inténtelo de nuevo más tarde",
      "CONFIRMATION_LABEL": "Si",
      "CANCEL_LABEL": "No"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "No se pudo subir el archivo adjunto, por favor inténtelo de nuevo",
      "LABEL_IDLE": "Subir archivo adjunto",
      "LABEL_UPLOADING": "Subiendo...",
      "LABEL_UPLOADED": "Subido correctamente",
      "LABEL_UPLOAD_FAILED": "Error al subir"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Clave de atributo es requerida",
      "FILTER_OPERATOR_REQUIRED": "El operador de filtro es requerido",
      "VALUE_REQUIRED": "El valor es requerido",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "El valor debe ser entre 1 y 998",
      "ACTION_PARAMETERS_REQUIRED": "Se requieren parámetros de acción",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Se requiere al menos una condición",
      "ATLEAST_ONE_ACTION_REQUIRED": "Se requiere al menos una acción",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "El valor debe estar entre 0 y 998",
      "ORDER_REQUIRED": "El orden es obligatorio",
      "ORDER_MUST_BE_AT_LEAST_ONE": "El orden debe ser al menos 1"
    },
    "NONE_OPTION": "Ninguna",
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Esta acción solo funciona cuando la fase de la regla está configurada como \"Antes del etiquetado\".",
      "SKIP_AUTO_LABELING": "Esta acción solo funciona cuando la fase de la regla está configurada como \"Antes del etiquetado\".",
      "MOVE_CONVERSATION_TO_INBOX": "Solo las conversaciones de correo y de chat web se pueden mover a una bandeja de entrada de correo, y un chat web solo si el contacto tiene dirección de correo electrónico. En caso contrario, la conversación no se mueve y en su lugar se añade una nota privada.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Inicia una nueva conversación con el contacto en la bandeja de entrada de correo electrónico seleccionada, le envía el mensaje por correo electrónico y resuelve la conversación. Esto ocurre cada vez que se ejecuta la regla. Si el contacto no tiene dirección de correo electrónico, no se envía nada y se añade una nota privada en su lugar.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Inicia una nueva conversación con el contacto en la bandeja de entrada de SMS seleccionada, le envía el mensaje por SMS y resuelve la conversación. Esto ocurre cada vez que se ejecuta la regla. El mensaje es texto sin formato y sin archivos adjuntos. Si el contacto no tiene número de teléfono, no se envía nada y se añade una nota privada en su lugar."
    },
    "NOTICES": {
      "AI_PROMPT": "Cada evaluación individual se cobra.",
      "INCOMING_MESSAGES_COUNT": "Esto se refiere al número de mensajes entrantes en la conversación.",
      "OUTGOING_MESSAGES_COUNT": "Esto se refiere al número de mensajes salientes en la conversación."
    },
    "PHASE": {
      "BEFORE_LABELING": "Antes del etiquetado",
      "AFTER_LABELING": "Después del etiquetado"
    },
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Mensaje entrante",
      "OUTGOING": "Mensaje saliente",
      "PRIVATE": "Nota privada",
      "AI_SUMMARY": "Resumen de IA"
    },
    "YES_NO_VALUES": {
      "YES": "Sí",
      "NO": "No"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Mensaje directo de Instagram",
      "FACEBOOK_COMMENT": "Comentario de Facebook"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Conversación creada",
      "CONVERSATION_UPDATED": "Conversación actualizada",
      "MESSAGE_CREATED": "Mensaje creado",
      "CONVERSATION_OPENED": "Conversación abierta",
      "CONVERSATION_RESOLVED": "Conversación resuelta",
      "PHONE_CALL_FINISHED": "Llamada finalizada"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Asignar a agente",
      "ASSIGN_TEAM": "Asignar un equipo",
      "ADD_LABEL": "Añadir una etiqueta",
      "REMOVE_LABEL": "Eliminar una etiqueta",
      "SEND_EMAIL_TO_TEAM": "Enviar un correo al equipo",
      "SEND_EMAIL_TRANSCRIPT": "Enviar transcripción por correo",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Enviar transcripción detallada por correo",
      "MUTE_CONVERSATION": "Silenciar conversación",
      "SNOOZE_CONVERSATION": "Posponer conversación",
      "RESOLVE_CONVERSATION": "Resolver conversación",
      "OPEN_CONVERSATION": "Abrir conversación",
      "SEND_WEBHOOK_EVENT": "Enviar evento de webhook",
      "SEND_ATTACHMENT": "Enviar adjunto",
      "SEND_MESSAGE": "Enviar un mensaje",
      "ADD_NOTE": "Añadir una nota",
      "CHANGE_PRIORITY": "Cambiar prioridad",
      "ADD_SLA": "Añadir SLA",
      "SKIP_AUTO_PRIORITY": "Omitir prioridad automática",
      "SKIP_AUTO_LABELING": "Omitir etiquetado automático",
      "AUTO_TRANSLATE": "Traducir mensaje",
      "AUTO_TRANSLATE_CONVERSATION": "Traducir conversación",
      "MOVE_CONVERSATION_TO_INBOX": "Mover conversación a bandeja de entrada",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Enviar un mensaje en una nueva conversación",
      "SEND_SMS_IN_NEW_CONVERSATION": "Enviar SMS en una nueva conversación",
      "STOP_PROCESSING_RULES": "Detener procesamiento de reglas"
    },
    "ATTRIBUTES": {
      "EXTENSION": "Extensión llamada",
      "AI_FILTER": "Filtro IA",
      "MESSAGE_TYPE": "Tipo de mensaje",
      "MESSAGE_CONTAINS": "Contenido del mensaje",
      "EMAIL": "Correo electrónico del contacto",
      "INBOX": "Bandeja de entrada",
      "CHANNEL_TYPE": "Tipo de bandeja de entrada",
      "CONVERSATION_LANGUAGE": "Idioma de la conversación",
      "PHONE_NUMBER": "Número de teléfono",
      "STATUS": "Estado",
      "BROWSER_LANGUAGE": "Idioma del navegador",
      "MAIL_SUBJECT": "Asunto del correo",
      "COUNTRY_NAME": "País",
      "MARKETPLACE_COUNTRY": "País del marketplace",
      "REFERER_LINK": "Enlace de referencia",
      "ASSIGNEE_NAME": "Asignado",
      "TEAM_NAME": "Equipo",
      "PRIORITY": "Prioridad",
      "CALL_DIRECTION": "Dirección de llamada",
      "MISSED_CALL": "Llamada perdida",
      "MISSED_CALL_COUNT": "Número de llamadas perdidas",
      "MESSAGE_SOURCE_TYPE": "Tipo de origen del mensaje",
      "INCOMING_MESSAGE_COUNT": "Número de mensajes entrantes",
      "OUTGOING_MESSAGE_COUNT": "Número de mensajes salientes",
      "LABEL": "Etiqueta",
      "EMAIL_RECIPIENTS": "Destinatario de correo",
      "EMAIL_AUTO_REPLY": "El correo es una respuesta automática",
      "ATTACHMENT_EXTENSION": "Extensión del adjunto",
      "WORKING_HOURS": "Dentro del horario laboral",
      "AGENT_REPLIED": "Un agente ha respondido desde el cambio de estado"
    },
    "WAIT": {
      "RUN_LABEL": "Ejecutar las acciones",
      "INSTANT": "Al ocurrir el evento",
      "DELAYED": "Con retraso",
      "TRIGGER_LABEL": "Esperar hasta que",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Una conversación permanece en un estado",
        "CUSTOMER_UNRESPONSIVE": "El cliente no responde a un agente",
        "AGENT_UNRESPONSIVE": "El cliente no recibe respuesta de un agente"
      },
      "STATUS_LABEL": "Estado",
      "STATUSES": {
        "OPEN": "Abierta",
        "PENDING": "Pendiente",
        "SNOOZED": "Pospuesta",
        "RESOLVED": "Resuelta"
      },
      "DELAY_LABEL": "Tiempo de espera",
      "DELAY_ERROR": "Introduce un tiempo de espera entre 1 minuto y 30 días",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} h",
        "DAYS": "{count} d"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Las acciones se ejecutan cuando una conversación lleva {duration} en estado {status}. Un cambio de estado antes las cancela. Las etiquetas, el horario laboral y las respuestas del agente se comprueban cuando termina la espera.",
        "CUSTOMER_UNRESPONSIVE": "Las acciones se ejecutan cuando el cliente lleva {duration} sin responder al mensaje de un agente. Una respuesta del cliente las cancela; un nuevo mensaje del agente reinicia la espera.",
        "AGENT_UNRESPONSIVE": "Las acciones se ejecutan cuando el cliente lleva {duration} esperando sin respuesta de un agente. Una respuesta del agente las cancela."
      }
    }
  }
}
